import { ensureJourneyDb, listTable, updateRow, writeAudit } from "../db";
import { setCredential } from "../db/credentials";
import { listLoginEvents } from "@hub";

function readBuyers() {
  try {
    return JSON.parse(localStorage.getItem("dh_buyers") || "[]");
  } catch {
    return [];
  }
}

export function listAdminUsers() {
  ensureJourneyDb();
  const users = listTable("users").map((row) => ({
    ...row,
    role: row.role_type,
  }));
  const seen = new Set(users.map((row) => row.id));
  readBuyers().forEach((buyer) => {
    if (seen.has(buyer.id)) return;
    users.push({
      id: buyer.id,
      role_type: "buyer",
      role: "buyer",
      name: buyer.name || "",
      email: buyer.email || "",
      status: buyer.status || "active",
      created_at: buyer.created_at || "",
    });
  });
  return users.sort((a, b) => String(a.name).localeCompare(String(b.name)));
}

export function getAdminUser(userId) {
  return listAdminUsers().find((row) => row.id === userId) || null;
}

export function setUserStatus(userId, status, actorId) {
  ensureJourneyDb();
  const next = status === "inactive" ? "inactive" : "active";
  const user = updateRow("users", userId, { status: next });
  writeAudit({
    user_id: actorId || userId,
    action_type: next === "inactive" ? "user.disable" : "user.enable",
    transaction_id: null,
    metadata: { target_user_id: userId, status: next },
  });
  return user;
}

export function resetUserPassword(userId, actorId) {
  const temp = `reset-${String(crypto.randomUUID()).slice(0, 8)}`;
  setCredential(userId, temp);
  const buyers = readBuyers();
  const index = buyers.findIndex((row) => row.id === userId);
  if (index >= 0) {
    buyers[index] = { ...buyers[index], password: temp };
    localStorage.setItem("dh_buyers", JSON.stringify(buyers));
  }
  writeAudit({
    user_id: actorId || userId,
    action_type: "user.password_reset",
    transaction_id: null,
    metadata: { target_user_id: userId, prototype: true },
  });
  return { user_id: userId, temporary_password: temp };
}

export function userDeskLinks(user) {
  const role = user?.role_type || user?.role;
  if (role === "agent") {
    return [
      { to: `/agent/dashboard?as=${user.id}`, label: "Desk" },
      { to: `/agent/files?as=${user.id}`, label: "Files" },
      { to: `/agent/documents?as=${user.id}`, label: "Documents & photos" },
      { to: `/agent/messages?as=${user.id}`, label: "Messages" },
    ];
  }
  if (role === "broker") {
    return [
      { to: `/broker/dashboard?as=${user.id}`, label: "Desk" },
      { to: `/broker/files?as=${user.id}`, label: "Files" },
      { to: `/broker/documents?as=${user.id}`, label: "Documents & photos" },
      { to: `/broker/messages?as=${user.id}`, label: "Messages" },
    ];
  }
  if (role === "seller") {
    return [{ to: "/seller/home", label: "Seller journey" }];
  }
  if (role === "buyer") {
    return [{ to: `/agent/client/${user.id}`, label: "Client file" }];
  }
  if (role === "admin") {
    return [
      { to: "/admin", label: "Admin desk" },
      { to: "/account?tab=privacy", label: "Change password" },
    ];
  }
  return [];
}

export function loginHistoryFor(userId) {
  return listLoginEvents(userId);
}
